import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavProductFactory extends NavFactory {
    protected static baseProductPath = '/admin/products';
    protected static items = [
        {
            code: NavItemCodes.PRODUCT_ADD,
            icon: IconCode.PRODUCT_ADD,
            label: 'PRODUCT.ADD',
            description: 'PRODUCT.ADD',
            path: [`${NavProductFactory.baseProductPath}/add`],
        },
        {
            code: NavItemCodes.PRODUCT_PG_DUPLICATE,
            icon: IconCode.PRODUCT_PG_DUPLICATE,
            label: 'PRODUCT.DUPLICATE',
            description: 'PRODUCT.DUPLICATE',
            path: ({productId}) => [NavProductFactory.baseProductPath, productId, 'pg', 'duplicate']
        },
        {
            code: NavItemCodes.PRODUCT_PG_EDIT,
            icon: IconCode.PRODUCT_PG_EDIT,
            label: 'PRODUCT.DEFINITION',
            description: 'PRODUCT.EDIT',
            path: ({productId}) => [NavProductFactory.baseProductPath, productId, 'pg', 'edit']
        },
        {
            code: NavItemCodes.PRODUCT_CPI_EDIT,
            icon: IconCode.PRODUCT_CPI_EDIT,
            label: 'PRODUCT.DEFINITION',
            description: 'PRODUCT.EDIT',
            path: ({productId}) => [NavProductFactory.baseProductPath, productId, 'cpi', 'edit']
        },
        {
            code: NavItemCodes.PRODUCT_CPI_DUPLICATE,
            icon: IconCode.PRODUCT_CPI_DUPLICATE,
            label: 'PRODUCT.DUPLICATE',
            description: 'PRODUCT.DUPLICATE',
            path: ({productId}) => [NavProductFactory.baseProductPath, productId, 'cpi', 'duplicate']
        },
        {
            code: NavItemCodes.PRODUCT_MANAGEMENT,
            icon: IconCode.PRODUCT_MANAGEMENT,
            label: 'NAV.PRODUCT_LIST.LABEL',
            description: 'NAV.PRODUCT_LIST.DESC',
            path: NavProductFactory.baseProductPath,
            permissionArea: PermissionArea.PRODUCT_MANAGEMENT
        },
    ];
}
